import './scss/app.scss';
import Uikit from "uikit";
import Icons from "uikit/dist/js/uikit-icons";
import litHtmlTemplate from "./layout/basicLayout";
import { html, render } from "lit";
import { registerTranslateConfig } from "lit-translate";

Uikit.use(Icons)

registerTranslateConfig({
	loader: lang => import(`/i18n/${lang}.json`).then(mod => mod.default)
})


const main = html`
	<main class="app-element">
		${litHtmlTemplate}
	</main>`

render(main, document.body)
